// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module--wrapper--3JQ__","BGMask":"styles-module--BGMask--PCqZe"};